<template>
  <div class="custom-kpi-widget content-wrapper">

    <div class="header">
      <span>{{title}}</span>
      <slot name="afterTitle"></slot>
    </div>

    <div class="body">
      <div class="data-wrapper">
        <h2 class="title">
          <count
            :to="parseFloat(value.toFixed(2))"
            :divider="divider"
          >
          </count>
          <slot name="afterValue"></slot>
        </h2>
        <span class="label">{{ label }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Count from '@/components/common/statistics/Count'
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      required: true,
      default: 0
    },
    label: {
      type: String,
      required: true
    },
    divider: {
      type: Number,
      required: false,
      default: 4000
    }
  },
  components: {
    Count
  }
}
</script>
<style lang="scss">
  .custom-kpi-widget {
    .va-card__body.va-card__body--padding-top {
      height: 100%;
    }
  }
</style>

<style lang="scss" scoped>

  $card-color: #F0F0F0;
  $primary-dark-gray: #48494B;

  .content-wrapper {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 1rem;
    background-color: $card-color;

    .header {
      display: flex;
      justify-content: space-between;
      color: $primary-dark-gray;
      font-weight: bold;
      padding-top: 0.5rem;
      padding-bottom: 0.5rem;
      border-bottom: solid 2px #d3d3d3;
    }

    .body {
      flex-grow: 1;
    }

    .data-wrapper {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      flex-basis: 100%;
      text-align: center;
      padding: 2rem;

        .title {
          font-size: 3rem;
          margin-bottom: 0.5rem;
          display: flex;
          justify-content: center;
          color: $primary-dark-gray;
        }

        .label {
          font-weight: bold;
          color: $primary-dark-gray;
        }
    }

    @media only screen and (max-width: 768px) {

      .header {
        flex-direction: column;
        text-align: center;
      }
    }

  }

  .custom-kpi-widget {
    height: calc(100% - 24px);
  }

</style>
